import { render, staticRenderFns } from "./datails.vue?vue&type=template&id=c260da8c&"
import script from "./datails.vue?vue&type=script&lang=js&"
export * from "./datails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports